// src/domains/onboarding/pages/PaymentPlaceholderPage.jsx
// Estrutura preparatória para integração futura com gateway de pagamento.
// Exibe informações do plano e um aviso claro de que a cobrança ainda não está ativa.
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const T = {
  brand: '#6B5876', accent: '#C9929A', border: '#E8E5EC',
  s2: '#FAF7FB', s3: '#F0EDF3', text: '#3D3447', text2: '#6B6070', muted: '#A8A1B0',
  sans: "'DM Sans',sans-serif", serif: "'Instrument Serif',serif",
};

export default function PaymentPlaceholderPage() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { plano } = location.state || {};

  return (
    <div style={{ minHeight: '100vh', background: T.s2, fontFamily: T.sans,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px 16px' }}>
      <div style={{ width: '100%', maxWidth: 480 }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontFamily: T.serif, fontSize: 32, color: T.brand }}>
            Agenda<span style={{ color: '#B5A2D2' }}>Pro</span>
          </div>
        </div>

        <div style={{ background: '#fff', borderRadius: 16, padding: 32,
          boxShadow: '0 4px 20px rgba(107,88,118,0.08)' }}>

          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>💳</div>
            <div style={{ fontFamily: T.serif, fontSize: 24, color: T.text, marginBottom: 8 }}>
              Pagamento
            </div>
            {plano && (
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8,
                padding: '6px 16px', background: T.s3, borderRadius: 20 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: T.brand }}>
                  Plano {plano.nome}
                </span>
                {plano.preco && (
                  <span style={{ fontSize: 13, color: T.text2 }}>
                    — R$ {plano.preco}/mês
                  </span>
                )}
              </div>
            )}
          </div>

          {/* Aviso de trial / integração pendente */}
          <div style={{ background: '#FFF9E6', border: '1px solid #FCD34D', borderRadius: 12,
            padding: '14px 16px', marginBottom: 24 }}>
            <div style={{ fontWeight: 600, fontSize: 14, color: '#92400E', marginBottom: 6 }}>
              🚧 Módulo de pagamento em integração
            </div>
            <p style={{ fontSize: 13, color: '#92400E', lineHeight: 1.6, margin: 0 }}>
              O sistema de cobrança automática ainda não está ativo. Você pode usar o AgendaPro
              gratuitamente durante o período de implantação.<br/>
              A cobrança será habilitada após a integração com o gateway de pagamento.
            </p>
          </div>

          {/* O que será integrado */}
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase',
              letterSpacing: 1, color: T.muted, marginBottom: 12 }}>
              Integração prevista
            </div>
            {[
              { icon: '🔒', title: 'Dados seguros', desc: 'Tokenização via Pagar.me ou Stripe — sem armazenar número do cartão' },
              { icon: '🔄', title: 'Cobrança recorrente', desc: 'Renovação automática mensal via cartão de crédito' },
              { icon: '📧', title: 'Notificações', desc: 'E-mail de confirmação, boleto e recibo a cada renovação' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start',
                padding: '10px 0', borderBottom: i < 2 ? `1px solid ${T.border}` : 'none' }}>
                <span style={{ fontSize: 20, flexShrink: 0 }}>{item.icon}</span>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 13, color: T.text }}>{item.title}</div>
                  <div style={{ fontSize: 12, color: T.muted, marginTop: 2, lineHeight: 1.5 }}>{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <button onClick={() => navigate('/login')}
            style={{ width: '100%', padding: 14, background: T.brand, color: '#fff',
              border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 500,
              cursor: 'pointer', fontFamily: T.sans }}>
            Acessar o sistema →
          </button>

          <p style={{ textAlign: 'center', fontSize: 12, color: T.muted, marginTop: 12, lineHeight: 1.5 }}>
            Você receberá um aviso por e-mail quando a cobrança for habilitada,
            com antecedência mínima de 7 dias.
          </p>
        </div>
      </div>
    </div>
  );
}
